import { CopilotDrawerFlyout } from './CopilotDrawerFlyout.jsx';
import { CopilotFloatingFab } from './CopilotFloatingFab.jsx';

/**
 * Astryx Canonical Copilot Component
 * Resolves between 'drawer_flyout' (default) and 'floating_fab' variants.
 */
export function CopilotDrawer({
  variant,
  open,
  onOpenChange,
  tenant,
  ...props
}) {
  const resolvedVariant =
    variant ||
    tenant?.settings?.copilot_variant ||
    tenant?.copilot_variant ||
    'drawer_flyout';

  if (resolvedVariant === 'floating_fab' || resolvedVariant === 'fab' || resolvedVariant === 'floating') {
    return (
      <CopilotFloatingFab
        open={open}
        onOpenChange={onOpenChange}
        tenant={tenant}
        {...props}
      />
    );
  }

  return (
    <CopilotDrawerFlyout
      open={open}
      onOpenChange={onOpenChange}
      tenant={tenant}
      {...props}
    />
  );
}

export { CopilotDrawerFlyout, parseMessageWithCitations } from './CopilotDrawerFlyout.jsx';
export { CopilotFloatingFab } from './CopilotFloatingFab.jsx';
export { BomCard } from './BomCard.jsx';

